import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { DETAILS_API_URL } from "./utils/bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import axios from "axios";
import $ from "jquery";
import VideoPlayer from "./common/VideoPlayer";
import SharePopup from "./common/Sharepopup";

const Detail = () => {
  const [detail, setDetail] = useState([]);
  const [iconImage, setIconImage] = useState("");

  const [link, setLink] = useState("");
  const [quote, setQuote] = useState("");
  const [twittermessage, setTwittermessage] = useState("");
  const [shareType, setShareType] = useState("");
  const { id, lang } = useParams();
  useEffect(() => {
    fetchList();
  }, []);
  const fetchList = async () => {
    let url = `${DETAILS_API_URL}&lang=${lang}&id=${id}`;
    axios.get(url).then((resp) => {
      let res = JSON.parse(resp.request.response);
      if (res._resultflag == 1) {
        setDetail(res.data);
        let image = "";
        if (res.data.type == "image") {
          image = "/assets/images/imgblack.svg";
        } else if (res.data.type == "text") {
          image = "/assets/images/textblack.svg";
        } else {
          image = "/assets/images/videoblack.svg";
        }
        setIconImage(image);
      }
    });
  };

  const playpause = (video_id) => {
    let playpausebtn = ".playpausebtn_" + video_id;
    $(".vjs-tech").each(function () {
      $(this).get(0).pause();
      $(".play_icon").attr("src", "/assets/images/play2.svg");
      if ($(this)[0].playerId != "myVideo_" + video_id) {
        $(this).attr("data-playpause", "1");
      }
    });
    let videoid = "myVideo_" + video_id + "_html5_api";

    let el = $("#" + videoid).get(0);
    let data_play = $("#" + videoid).attr("data-playpause");
    data_play = data_play ? data_play.toString() : data_play;

    if (data_play && data_play == 1) {
      $("#" + videoid).attr("data-playpause", "0");
      $(playpausebtn).attr("src", "/assets/images/pause.svg");
      $(playpausebtn).fadeOut();
      el.play();
    } else if (!data_play) {
      $("#" + videoid).attr("data-playpause", "0");
      $(playpausebtn).attr("src", "/assets/images/pause.svg");
      el.play();
      $(playpausebtn).fadeOut();
      // $('.videoplay_icon').show();
    } else {
      $("#" + videoid).attr("data-playpause", "1");
      $(playpausebtn).attr("src", "/assets/images/play2.svg");
      el.pause();
      $(playpausebtn).fadeIn();
      // $('.videoplay_icon').show();
    }
  };

  const hideplayIcon = (video_id, type) => {
    let timeout = null;
    if (timeout) {
      clearTimeout(timeout);
    }
    let playpausebtn = ".playpausebtn_" + video_id;

    let videoid = "myVideo_" + video_id + "_html5_api";
    let data_play = $("#" + videoid).attr("data-playpause");
    if (data_play == 0) {
      timeout = setTimeout(() => {
        $(playpausebtn).fadeOut();
      }, 500);
    } else {
      $(playpausebtn).fadeIn();
    }
  };

  const share = (id, share_text, type = "detail") => {
    $(".popup_fixed_bg").show();
    let params = type == "topic" ? `topic/${id}` : id;
    let link = `https://www.narendramodi.in/parikshapecharcha/${params}`;
    setLink(link);
    setQuote(share_text ? share_text : "");
    setTwittermessage(share_text ? share_text : "");
    setShareType(type);
  };

  const handlePlayerReady = (player) => {
    // you can handle player events here
    player.on("waiting", () => {
      console.log("player is waiting");
    });
    player.on("play", () => {
      $(".videoplay_icon").hide();
      // console.log('playing');F
    });
    player.on("dispose", () => {
      console.log("player will dispose");
    });
  };

  const getArticleTypeHtml = (type) => {
    if (type == "video") {
      return (
        <>
          <div className="videtab_div">
            <div className="video_tab video_tab2">
              <VideoPlayer
                onReady={handlePlayerReady}
                id={detail.id}
                keyi={detail.id}
                key={detail.id}
                video_url={detail.video_url}
                thumb={detail.thumb_url}
              />
              <span
                className="play_layer"
                onClick={() => {
                  playpause(detail.id);
                }}
                onMouseMove={() => {
                  hideplayIcon(detail.id);
                }}
              >
                <img
                  src="/assets/images/play2.svg"
                  className={"play_icon playpausebtn_" + detail.id}
                  alt=""
                />
              </span>
              <span
                className="main_play"
                onClick={() => {
                  playpause(detail.id);
                }}
              ></span>
            </div>
            <ul className="share_list share_listdetail">
              <li>
                <button
                  onClick={() => share(detail.id, detail.share_text, "youtube")}
                >
                  <img
                    src="/assets/images/shareorange.svg"
                    className="sh_or"
                    alt=""
                  />
                  <img
                    src="/assets/images/sharewhite.svg"
                    className="sh_wh"
                    alt=""
                  />{" "}
                  Share Video
                </button>
              </li>
            </ul>
          </div>
        </>
      );
    } else if (type == "image") {
      return (
        <>
          <div>
            <div className="image_tab image_tab3">
              <img
                src={detail.url}
                className="img-fluid d-block mx-auto img_detail_img"
                alt=""
              />
            </div>
            <ul className="share_list share_listdetail">
              <li>
                <button
                  onClick={() => share(detail.id, detail.share_text, "image")}
                >
                  <img
                    src="/assets/images/shareorange.svg"
                    className="sh_or"
                    alt=""
                  />
                  <img
                    src="/assets/images/sharewhite.svg"
                    className="sh_wh"
                    alt=""
                  />{" "}
                  Share Image
                </button>
              </li>
            </ul>
          </div>
        </>
      );
    } else if (type == "text") {
      return (
        <>
          <div>
            <div className="text_tab text_tab2">
              <h5>{detail.title}</h5>
              <div className="text_bg">
                <PerfectScrollbar>
                  <p
                    dangerouslySetInnerHTML={{ __html: detail.description }}
                  ></p>
                </PerfectScrollbar>
              </div>
            </div>
          </div>
        </>
      );
    }
  };
  console.log("detail", detail);
  const params = new URLSearchParams(window.location.search);
  return (
    <>
      <div className="header_bg_topic">
        <div className="header_detail_bg">
          <div className="container-fluid">
            <ul className="header_top header_detail">
              <li>
                {lang == "en" ? (
                  <Link to="">
                    <img src="/assets/images/PPC-Final-Logo_en.png" alt="" />
                  </Link>
                ) : (
                  <Link to="">
                    <img src="/assets/images/PPC-Final-Logo_hi.png" alt="" />
                  </Link>
                )}
              </li>

              <li>
                <Link
                  to={
                    window.location.href.indexOf("appversion") != -1
                      ? "/?" + params
                      : "https://www.narendramodi.in/parikshapecharcha"
                  }
                  target={
                    window.location.href.indexOf("appversion") != -1
                      ? "_parent"
                      : "_blank"
                  }
                  className="explore_ques_link"
                >
                  {lang == "en" ? (
                    <>Explore More Questions</>
                  ) : (
                    <>और प्रश्न देखें</>
                  )}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="topicdetailtabpad">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="topic_detail">
                  <Link
                    to={
                      window.location.href.indexOf("appversion") != -1
                        ? "/?" + params
                        : "https://www.narendramodi.in/parikshapecharcha"
                    }
                    target={
                      window.location.href.indexOf("appversion") != -1
                        ? "_parent"
                        : "_blank"
                    }
                    className="backtopicdetail"
                  >
                    <img
                      src="/assets/images/backarrow.svg"
                      className=""
                      alt=""
                    />
                    <span>Back</span>
                  </Link>

                  <img
                    src="/assets/images/book.png"
                    className="bookdetail"
                    alt=""
                  />
                  <img
                    src="/assets/images/girl.png"
                    className="girletail"
                    alt=""
                  />

                  <div className="tpicdetail_wid">
                    {/* <img
                      src="/assets/images/img-1.jpg"
                      className="image_size_detail"
                      alt=""
                    /> */}
                    {getArticleTypeHtml(detail.type)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="thanyou_bg">
          <div className="thanyou_content">
            <h3>Thank You</h3>
            <img src="/assets/images/illu1.png" alt="" />
          </div>
        </div>
      </div>
      <SharePopup
        link={link}
        quote={quote}
        twittermessage={twittermessage}
        shareType={shareType}
      />
    </>
  );
};

export default Detail;
